/* import __COLOCATED_TEMPLATE__ from './tantcap-neg.hbs'; */
import Component from '@glimmer/component';
import type { CapacitorItem } from './bypass-capacitors-container';

interface TantalumCapacitorToNegativeArgs {
  circuitValues: CapacitorItem;
  index: number;
}

export default class TantalumCapacitorToNegative extends Component<TantalumCapacitorToNegativeArgs> {
  yTranslate = 0;

  get xTranslate(): number {
    return this.args.index * 100;
  }
}
